import { useEffect, useState } from 'react';
import React, { Component } from 'react';
import axios from 'axios';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import randomColor from 'randomcolor';

import CanvasJSReact from '@canvasjs/react-charts';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Line } from 'react-chartjs-2';
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

// Function to generate random colors
function generateRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}


const LineChart = ({ gridData, selectedCombinedLineColumns, verticalLineLabel,
    horizantalLineLabel, lineRightList, connectionNameValue, reportName,
    catalogs, schemas, tables, columns, xandLabelLineColumns }) => {

    // alert(JSON.stringify(selectedCombinedLineColumns)+"--"+JSON.stringify(verticalLineLabel)+"--"+JSON.stringify(horizantalLineLabel)+"--"+JSON.stringify(lineRightList));
    const navigate = useNavigate();
    const location = useLocation();
    const [iframeUrl, setIframeUrl] = useState('');
    console.log(JSON.stringify(location.state) + "location.state--------------");

    let selectedCombinedLineColumnsValue = '';
    let verticalLineLabelValue = '';
    let horizantalLineLabelValue = '';
    let lineRightListValue = '';
    let connectionName = '';
    let reportNameValue = '';
    let gridDataValue = '';
    let catalogsList = '';
    let schemasList = '';
    let tablesList = '';
    let columnsList = '';
    let xandLabelLineColumnsValue = '';

    const [lineDataSet, setLineDataSet] = useState([]);

    // Generate an array of random colors
    const randomColors = randomColor({ count: lineDataSet.length });

    const [xaxis, setXaxis] = useState([]);
    const [yaxis, setYaxis] = useState([]);

    if (location.state && location.state.selectedCombinedLineColumns !== undefined) {
        const { gridData, selectedCombinedLineColumns, verticalLineLabel,
            horizantalLineLabel, lineRightList, connectionNameValue, reportName, xandLabelLineColumns } = location.state;

        console.log(selectedCombinedLineColumns); // Output: "name"
        console.log(verticalLineLabel); // Output: "id"
        console.log(horizantalLineLabel); // Output: "Name Only"
        console.log(lineRightList); // Output: "Name Only"

        selectedCombinedLineColumnsValue = location.state.selectedCombinedLineColumns;
        verticalLineLabelValue = location.state.verticalLineLabel;
        horizantalLineLabelValue = location.state.horizantalLineLabel;
        lineRightListValue = location.state.lineRightList;
        connectionName = connectionNameValue;
        reportNameValue = reportName;
        gridDataValue = gridData;

        catalogsList = location.state.catalogs;
        schemasList = location.state.schemas;
        tablesList = location.state.tables;
        columnsList = location.state.columns;
        xandLabelLineColumnsValue = xandLabelLineColumns;


        console.log(JSON.stringify(selectedCombinedLineColumnsValue) + "selectedCombinedLineColumnsValueLOC"
            + JSON.stringify(verticalLineLabelValue) + "verticalLabelValueLOC"
            + JSON.stringify(horizantalLineLabelValue) + "horizantalLineLabelValueLOC"
            + JSON.stringify(lineRightListValue) + "lineRightListValueLOC");
    } else {

        selectedCombinedLineColumnsValue = selectedCombinedLineColumns;
        verticalLineLabelValue = verticalLineLabel
        horizantalLineLabelValue = horizantalLineLabel;
        lineRightListValue = lineRightList;
        connectionName = connectionNameValue;
        reportNameValue = reportName;
        gridDataValue = gridData;

        catalogsList = catalogs;
        schemasList = schemas;
        tablesList = tables;
        columnsList = columns;
        xandLabelLineColumnsValue = xandLabelLineColumns;

        console.log(JSON.stringify(selectedCombinedLineColumnsValue) + "selectedCombinedLineColumnsValue");
        console.log(JSON.stringify(verticalLineLabelValue) + "verticalLineLabelValue");
        console.log(JSON.stringify(horizantalLineLabelValue) + "horizantalLineLabelValue");
        console.log(JSON.stringify(lineRightListValue) + "lineRightListValue"
            + JSON.stringify(selectedCombinedLineColumnsValue) + "selectedCombinedLineColumnsValue"
            + JSON.stringify(verticalLineLabelValue) + "verticalLineLabelValue"
            + JSON.stringify(horizantalLineLabelValue) + "horizantalLineLabelValue");
    }


    const handleClick = () => {
        console.log('Line chart clicked!');

        navigate('/lineChart', {
            state: {
                selectedCombinedLineColumns, verticalLineLabel, horizantalLineLabel, lineRightList,
                connectionName, reportNameValue
            }
        });
        // navigate(`/pieChart?selectedCombinedColumns=${selectedCombinedColumns}&selectedIdsCombinedColumns=${selectedIdsCombinedColumns}&selectedLabelType=${selectedLabelType}`);
        //  const urlWithParams = `/pieChart?selectedCombinedColumns=${selectedCombinedColumns}&selectedIdsCombinedColumns=${selectedIdsCombinedColumns}&selectedLabelType=${selectedLabelType}`;
        //  setIframeUrl(urlWithParams);
    };

    console.log(JSON.stringify(selectedCombinedLineColumnsValue) + "selectedCombinedLineColumnsValue");
    console.log(JSON.stringify(verticalLineLabelValue) + "verticalLineLabelValue");
    console.log(JSON.stringify(horizantalLineLabelValue) + "horizantalLineLabelValue");
    console.log(JSON.stringify(lineRightListValue) + "lineRightListValue");




    const [data, setData] = useState({
        labels: [],
        datasets: [],
    });
    useEffect(() => {


        const datasets = [];
        if (xandLabelLineColumnsValue && xandLabelLineColumnsValue.length > 0) {
            xandLabelLineColumnsValue.forEach((column) => {
                // Check if the column is present in rightListValue
                if (lineRightListValue.includes(column)) {
                    const columnIndex = xandLabelLineColumnsValue.indexOf(column);
                    const dataset = gridDataValue.map((data) => ({
                        y: parseInt(data[columnIndex], 10),
                        label: data[xandLabelLineColumnsValue.indexOf(selectedCombinedLineColumnsValue)],
                        color: generateRandomColor()
                    }));

                    // Create an object for the dataset and set its properties
                    const datasetObject = {
                        type: "line", // Set the chart type to column/bar
                        dataPoints: dataset,
                        // Add other options as needed
                        // For example:
                        name: column, // Set the dataset name to the column name
                        showInLegend: true, // Show the dataset in the legend
                    };

                    datasets.push(datasetObject);



                }
            });
            console.log(JSON.stringify(datasets) + "datasets");
            setLineDataSet(datasets);
            console.log(JSON.stringify(lineDataSet) + "lineDataSet");

        }



        // const datasets1 = gridDataValue.map(data => ({
        //     y: parseInt(data[1], 10),
        //     label: data[0],
        //     color: generateRandomColor()
        // }));

        // setLineDataSet(datasets1);
        // console.log(JSON.stringify(datasets) + "datasets----");

    },
        [selectedCombinedLineColumnsValue, verticalLineLabelValue, horizantalLineLabelValue, lineRightListValue])
    console.log(JSON.stringify(lineDataSet) + "lineDatasetOUT :");

    const options = {
        animationEnabled: true,
        exportEnabled: true,
        theme: "light2", // "light1", "dark1", "dark2"
        title: {
            text: "Line Chart "
        },
        axisY: {

            title: `${verticalLineLabelValue}`,

        },
        axisX: {
            title: `${horizantalLineLabelValue}`,

        },
        data: lineDataSet
        // data: [{
        //     type: "line",

        //     toolTipContent: "{x}: {y}",
        //     dataPoints: lineDataSet
        //     // dataPoints: [
        //     // 	{ x: 1, y: 64 },
        //     // 	{ x: 2, y: 61 },
        //     // 	{ x: 3, y: 64 },
        //     // 	{ x: 4, y: 62 },
        //     // 	{ x: 5, y: 64 },
        //     // 	{ x: 6, y: 60 },
        //     // 	{ x: 7, y: 58 },
        //     // 	{ x: 8, y: 59 },
        //     // 	{ x: 9, y: 53 },
        //     // 	{ x: 10, y: 54 },
        //     // 	{ x: 11, y: 61 },
        //     // 	{ x: 12, y: 60 },
        //     // 	{ x: 13, y: 55 },
        //     // 	{ x: 14, y: 60 },
        //     // 	{ x: 15, y: 56 },
        //     // 	{ x: 16, y: 60 },
        //     // 	{ x: 17, y: 59.5 },
        //     // 	{ x: 18, y: 63 },
        //     // 	{ x: 19, y: 58 },
        //     // 	{ x: 20, y: 54 },
        //     // 	{ x: 21, y: 59 },
        //     // 	{ x: 22, y: 64 },
        //     // 	{ x: 23, y: 59 }
        //     // ]
        // }]
    }
    return (
        <div className="chart" style={location.state ? { width: '98%', height: '450px' } : { width: '50%', height: '300px' }}>
            {location.state && location.state.selectedCombinedLineColumns !== undefined ? (
                <>
                    {/* <h2>Connection Name : {connectionName}</h2> */}
                    {/* <h3>Report Name : {reportNameValue}</h3> */}

                    <Link to="/QueryBuilder" state={{
                        connectionName: connectionName,
                        reportName: reportNameValue,
                        catalogs: catalogsList,
                        schemas: schemasList,
                        tables: tablesList,
                        columns: columnsList
                    }}>Home</Link>
                    <CanvasJSChart data={data} options={options} />
                </>

            ) : (
                <CanvasJSChart data={data} className="left-align" options={options} onClick={() => handleClick()} />
            )}
        </div>





    )

}
export default LineChart; 